module.exports = __webpack_public_path__ + "img/UPLOAD.2356d0d1.svg";